/**
 * Машиночитаемые коды ошибок. Клиент выбирает текст по коду (i18n), сообщение из
 * ответа сервера — только для логов и отладки.
 */
export const AppErrorCode = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    INVALID_INIT_DATA: 'INVALID_INIT_DATA',
    INIT_DATA_EXPIRED: 'INIT_DATA_EXPIRED',
    USER_BANNED: 'USER_BANNED',
    ONBOARDING_REQUIRED: 'ONBOARDING_REQUIRED',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    RATE_LIMITED: 'RATE_LIMITED',
    ALREADY_IN_QUEUE: 'ALREADY_IN_QUEUE',
    NOT_IN_QUEUE: 'NOT_IN_QUEUE',
    ALREADY_IN_CHAT: 'ALREADY_IN_CHAT',
    QUEUE_TIMEOUT: 'QUEUE_TIMEOUT',
    CHAT_NOT_FOUND: 'CHAT_NOT_FOUND',
    CHAT_CLOSED: 'CHAT_CLOSED',
    NOT_CHAT_PARTICIPANT: 'NOT_CHAT_PARTICIPANT',
    MEDIA_TOO_LARGE: 'MEDIA_TOO_LARGE',
    MEDIA_UNSUPPORTED_TYPE: 'MEDIA_UNSUPPORTED_TYPE',
    MEDIA_INFECTED: 'MEDIA_INFECTED',
    MEDIA_UPLOAD_FAILED: 'MEDIA_UPLOAD_FAILED',
    MEDIA_NOT_FOUND: 'MEDIA_NOT_FOUND',
    /** Голосовое длиннее предела, заданного в панели. */
    VOICE_TOO_LONG: 'VOICE_TOO_LONG',
    /** Дружба доступна только вошедшим через Telegram. */
    AUTH_REQUIRED_FOR_FRIENDS: 'AUTH_REQUIRED_FOR_FRIENDS',
    FRIEND_REQUEST_NOT_FOUND: 'FRIEND_REQUEST_NOT_FOUND',
    FRIEND_REQUEST_EXPIRED: 'FRIEND_REQUEST_EXPIRED',
    ALREADY_FRIENDS: 'ALREADY_FRIENDS',
    REPORT_DUPLICATE: 'REPORT_DUPLICATE',
    REPORT_TARGET_NOT_FOUND: 'REPORT_TARGET_NOT_FOUND',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    /** Зависимость сервиса недоступна: ошибка временная, повтор имеет смысл. */
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
};
//# sourceMappingURL=errors.js.map